import React, { useState } from 'react'
import './index.less'

export interface AppTextProps {
	value?: string
	placeholder?: string
	onChange?: (value: string) => void
	readonly?: boolean
	textHeight?:number
	state?:'default'|'error'|'active'|'readonly'
}

const initState = (props: AppTextProps) =>{
    if(props.readonly) return 'readonly'
    return props.state || 'default'
}

export const AppText = (props:AppTextProps) =>{

	const[value ,setValue] = useState(props.value || '');
	const [state, setState] = useState(initState(props));

	const hanldFocus = () =>{
        if(props.readonly && state==='readonly') return;
        setState('active');
    }

    const hanldBlur = () =>{
        if(props.readonly) return;
		let newValue = refText.current.value
		if(newValue !== value){
			props.onChange && props.onChange(newValue)
			setValue(newValue)
		}
        setState('default')
    }



	const refText = React.createRef<HTMLTextAreaElement>()

	return <textarea
	style = {{height:props.textHeight||60}}
	data-state = {state}
	ref = {refText}
	readOnly={props.readonly || false}
	placeholder={props.placeholder || ''}
	defaultValue={value || ''}
	className="app-textarea"
	onBlur={hanldBlur}
	onFocus={hanldFocus}
			/>
}


// WEBPACK FOOTER //
// ./src/qcc/AppText/index.tsx